import type { JSX } from 'react'

interface Props { rows?: number; columns?: number }

export function TableSkeleton({ rows = 5, columns = 4 }: Props): JSX.Element {
  return (
    <div role="status" aria-label="Loading">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-4 p-3 border-b border-gray-100">
          {Array.from({ length: columns }).map((_, c) => (
            <div key={c} className="h-4 bg-gray-200 rounded animate-pulse flex-1" />
          ))}
        </div>
      ))}
    </div>
  )
}

export default TableSkeleton
